<template>
  <a-card title="信息设置">
    <a-form-model ref="form" :model="formdata" v-bind="layout">
      <a-form-model-item label="账号">
        <a-input disabled readonly :value="formdata.phone" type="text" autocomplete="off"></a-input>
      </a-form-model-item>
      <a-form-model-item label="登录密码">
        <a-button @click="modal.visible = true">修改密码</a-button>
      </a-form-model-item>
      <a-form-model-item label="公司名">
        <a-input v-model="formdata.company_name" type="text" autocomplete="off"></a-input>
      </a-form-model-item>
      <a-form-model-item label="公司电话">
        <a-input v-model="formdata.company_phone" type="text" autocomplete="off"></a-input>
      </a-form-model-item>
      <a-form-model-item label="邮箱">
        <a-input v-model="formdata.email" type="email" autocomplete="off"></a-input>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 16, offset: 6 }">
        <a-button type="primary" @click="onSubmit">保存</a-button>
      </a-form-model-item>
    </a-form-model>
    <a-modal v-model="modal.visible" title="修改密码" :footer="null">
      <form-reset-pwd @success="onSuccess"></form-reset-pwd>
    </a-modal>
  </a-card>
</template>
<script>
import { mapActions } from "vuex";
export default {
  components: {
    formResetPwd: () => import("../forms/resetpwd"),
  },
  data() {
    return {
      formdata: {
        phone: "",
        email: "",
        company_name: "",
        company_phone: "",
      },
      layout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 16 },
      },
      modal: {
        visible: false,
      },
    };
  },
  async mounted() {
    const user = await this.getUser();
    this.formdata = Object.assign({}, user);
  },
  methods: {
    ...mapActions("user", ["getUser", "update"]),
    onSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const data = Object.assign({}, this.formdata);
          delete data.phone;
          const response = await this.update(data);
          if (response && response.code == 200) {
            this.$message.success("操作成功");
          }
        }
      });
    },
    async onSuccess() {
      this.$message.success("操作成功");
      this.modal.visible = false;
    },
  },
};
</script>
